/*
* Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
*/

/**
 * Defines the default marker size which is used to define the width and height
 * of an Event marker.
 */
export enum DefaultMarkerSize {
  width = 40,
  height = 40
}

const POSITION = {
  shape : {
    batteryX : 16,
    batteryY : 13,
    normalX  : 13,
    normalY  : 13.5
  },
  outline : {
    batteryX : 13,
    battaryY : 14,
    normalX  : 10,
    normalY  : 14.5
  }
};

/**
 * Defines the default Event Marker which is used to render the background svg.
 *
 * ```typescript
 *
 *   return new Graphic({
 *     geometry   : {type: 'point', latitude, longitude},
 *     symbol     : {
 *       type : 'picture-marker',
 *       url  : getEventMarker(color),
 *       width,
 *       height
 *     }
 *   });
 *
 * ```
 *
 */
const getEventMarker = (path: string, color: string, isBatteryIcon: boolean = false) => {
  const {width, height}  = DefaultMarkerSize;
  const {shape, outline} = POSITION;
  const shapeX = !isBatteryIcon ? shape.normalX : shape.batteryX;
  const shapeY = !isBatteryIcon ? shape.normalY : shape.batteryY;
  const outlineX = !isBatteryIcon ? outline.normalX : outline.batteryX;
  const outlineY = !isBatteryIcon ? outline.normalY : outline.battaryY;
  
  const svg = (`
    <svg width='${width}' height='${height}' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'>
      <defs>
        <path d='M22.95 12.6C22.95 18.12 18.47 22.6 12.95 22.6C7.43 22.6 2.95 18.12 2.95 12.6C2.95 7.08 7.43 2.6 12.95 2.6C18.47 2.6 22.95 7.08 22.95 12.6Z' id='bBngP3V9k'></path>
        <clipPath id='clipa3GZ6x56MK'><use x='8' y='9' xlink:href='#bBngP3V9k' opacity='1'></use></clipPath>
        <path fill-rule='evenodd' clip-rule='evenodd' d='${path}' id='a3UG7N770p' fill='${color}'></path>
      </defs>
      <g>
        <g>
          <use x='8' y='9' xlink:href='#bBngP3V9k' opacity='1' fill='#ffffff' fill-opacity='1'></use>
          <g clip-path='url(#clipa3GZ6x56MK)'><use x='8' y='9' xlink:href='#bBngP3V9k' opacity='1' fill-opacity='0' stroke='#f2f2ef' stroke-width='1' stroke-opacity='1'></use></g>
        </g>
        <g>
          <use x='${shapeX}' y='${shapeY}' xlink:href='#a3UG7N770p' opacity='1' fill='${color}' fill-opacity='1'></use>
          <g><use x='${outlineX}' y='${outlineY}' xlink:href='#a3UG7N770p' opacity='1' fill-opacity='0' stroke='#000000' stroke-width='1' stroke-opacity='0'></use></g>
        </g>
      </g>
    </svg>
  `);
  return `data:image/svg+xml;base64,${btoa(svg.trim())}`;
};
  
export default getEventMarker;
